import styled, { css } from 'styled-components'
import { BaseInput } from '@components'

export const Wrapper = styled.div<{ $mt?: number }>`
  ${({ $mt }) => $mt && `margin-top: ${$mt}px;`};
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
  width: 100%;
`

export const LabelText = styled.span`
  margin-bottom: 6px;
  font-weight: 500;
  font-size: 14px;
  text-shadow:
    0 1px 2px rgba(10, 13, 18, 0.05),
    0 0 0 #f4ebff;
`

export const StyledLabel = styled.label<{ $error?: boolean }>(
  ({ theme, $error }) => css`
    box-shadow: 0 0 0 1px ${$error ? theme.colors.error : 'transparent'};
    border-radius: 16px;
    background-color: white;
    padding: 16px 14px;
    display: flex;
    align-items: center;
    gap: 8px;
    transition: box-shadow 0.2s ease-in-out;

    &:has(input:not(:placeholder-shown)) {
      ${!$error &&
      css`
        box-shadow:
          0 1px 2px rgba(10, 13, 18, 0.05),
          0 0 0 1px #d5d7da;
      `}
    }

    &:has(input:not(:placeholder-shown, :focus, :valid)) {
      box-shadow: 0 0 0 1px ${theme.colors.error};
    }

    /* &:focus-within { */
    &:has(input:focus) {
      box-shadow:
        0 0 0 1px ${theme.colors.coldCharcoal400},
        0 0 6px ${theme.colors.coldCharcoal300};
    }
  `,
)

export const StyledInput = styled(BaseInput)<{ $isInValid?: boolean }>`
  flex-grow: 1;
  font-size: 16px;
  background-color: transparent;

  &::placeholder {
    color: ${({ theme }) => theme.colors.textTertiary};
  }

  &:not([type='email'], :placeholder-shown) {
    & ~ .show-pass {
      opacity: 1;
    }
  }
`

export const InputIcon = styled.div`
  width: 20px;
  height: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
`

export const ShowPass = styled.div`
  opacity: 0;
  transition: opacity 0.3s ease-in-out;
  width: 16px;
  height: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
`
